import request from '@/utils/request'

export const createUser = (email: any, password: any, firstname: string, lastname: string) =>
  request({
    url: '/users/create',
    method: 'post',
    data: { email: email, password, firstname, lastname }
  })
export const login = (username: any, password: any) =>
  request({
    url: '/users/login',
    method: 'post',
    data: { email: username, password }
  })

export function getCookie(cname) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
export const cookieAuth = () => {
  if (getCookie('connect.sid') != '') {
    return request({
      url: '/users/cookieAuth',
      method: 'post'
    })
  } else {
    return { data: { authenticated: false } }
  }
}
export const logout = () =>
  request({
    url: '/users/logout',
    method: 'get'
  })
